<template>
    <div
        role="status"
        aria-live="polite"
        class="ReaderUnsupportedFormat flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
        dusk="ReaderUnsupportedFormat"
    >
        <p class="text-sm opacity-60">
            {{ localizations[lang].unsupportedFormat }}
        </p>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
    name: 'ReaderUnsupportedFormat',
    computed: {
        ...mapState(['localizations', 'lang']),
    },
    mounted() {
        // The message is all this session shows, so it marks the initial content ready
        // the way a viewer does on first paint, or a mobile host never lifts its overlay.
        this.setLoadingState({ isLoading: false });
        this.markInitialContentReady();
    },
    methods: {
        ...mapMutations(['setLoadingState', 'markInitialContentReady']),
    },
};
</script>
